import React from 'react';
import HeroSection from '../../components/shared/HeroSection';
import CompanyStatement from './sections/CompanyStatement';
import WhatWeDo from './sections/WhatWeDo';
import ServiceAreas from './sections/ServiceAreas';
import ContactQuickLink from './sections/ContactQuickLink';
import Footer from '../../components/shared/Footer';

const Home = () => {
  return (
    <div>
      {/* Hero Section with full-screen image */}
      <HeroSection 
        backgroundImage="/assets/asset-11.jpg"
        title="Functional Safety"
        subtitle="System Inc."
      />
      
      {/* Company Statement & Mission */}
      <CompanyStatement />
      
      {/* What We Do */}
      <WhatWeDo />
      
      {/* Service Areas */}
      <ServiceAreas />
      
      {/* Contact Quick-Link */}
      <ContactQuickLink />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;